import React, { useEffect, useMemo } from 'react';
import MyVenuesLayer from './MyVenuesLayer';
import CategoriesLayer from './CategoriesLayer';
import VenueVerificationLayer from './VenueVerificationLayer';
import SubscriptionControlLayer from './SubscriptionControlLayer';
import MySubscriptionLayer from './MySubscriptionLayer';
import UserManagementLayer from './UserManagementLayer';
import ContentModerationLayer from './ContentModerationLayer';

import PositionManagementLayer from './PositionManagementLayer';
import EmployeeManagementLayer from './EmployeeManagementLayer';
import { useAuth } from '../context/AuthContext';
import { useApplicationContext } from '../context/ApplicationContext';
import { applicationTabs } from '../helper/applicationTabs';

const APP_TYPE = process.env.REACT_APP_APP_TYPE || 'dev';

const ApplicationsLayer = () => {
  const { user } = useAuth();
  const { activeTabId, setActiveTabId } = useApplicationContext();

  const allowedTabs = useMemo(() => {
    const checkPermission = (permission) => {
      if (!user) return false;
      if (permission === 'authenticated') return true;
      if (permission === 'ROLE_ADMIN') return user.role === 'admin';
      if (user.role === 'admin') return true;
      if (!user.permissions) return false;
      return user.permissions.includes(permission);
    };

    return applicationTabs
      .filter(tab => checkPermission(tab.permission))
      .filter(tab => APP_TYPE !== 'admin' || tab.id !== 'my-plan');
  }, [user]);

  // Map IDs to Content
  const contentMap = {
    'my-venues': <MyVenuesLayer />,
    'my-plan': <MySubscriptionLayer />,
    'categories': <CategoriesLayer />,
    'venue-verification': <VenueVerificationLayer />,
    'subscriptions': <SubscriptionControlLayer />,
    'user-management': <UserManagementLayer />,
    'moderation': <ContentModerationLayer />,

    'positions': <PositionManagementLayer />,
    'employees': <EmployeeManagementLayer />
  };

  useEffect(() => {
    // If current activeTabId is not allowed (or null), set to first allowed
    const isAllowed = allowedTabs.find(tab => tab.id === activeTabId);
    if (!isAllowed && allowedTabs.length > 0) {
      setActiveTabId(allowedTabs[0].id);
    }
  }, [allowedTabs, activeTabId, setActiveTabId]);

  const activeContent = contentMap[activeTabId];

  return (
    <>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
             {activeContent}
        </div>
      </div>
    </>
  );
};

export default ApplicationsLayer;
